import { Typography } from "@pondigitalsolutions/pon-component-library";
import { ISbStoryData } from "@storyblok/react";
import { Link } from "react-router-dom";
import type { PreservedSearchState } from "@hooks/usePreservedSearchQuery";
import { twMerge } from "tailwind-merge";
import { NewsMetaData } from "./NewsMetaData";
import { HoverArrow } from "../HoverArrow";
import { LeadershipLabel } from "./LeadershipLabel";

interface FeaturedNewsItemProps {
  title: string;
  slug: string;
  date: string;
  imageUrl: string;
  categories?: ISbStoryData[];
  brand?: ISbStoryData[];
  isLeadership?: boolean;
  className?: string;
  linkState?: PreservedSearchState;
}
export const FeaturedNewsItem = ({
  title,
  slug,
  date,
  imageUrl,
  categories,
  brand,
  isLeadership = false,
  className,
  linkState,
}: FeaturedNewsItemProps) => {
  return (
    <div
      className={twMerge(
        "h-80 lg:h-128",
        "group relative flex items-end",
        "bg-gradient-to-t from-secondary-700/80 from-0% via-secondary-700/70 via-25% to-transparent to-50% bg-cover bg-center bg-no-repeat",
        className
      )}
      style={{
        backgroundImage: `linear-gradient(var(--tw-gradient-stops)), url(${imageUrl})`,
      }}
      data-testid="featured-news-item"
    >
      {isLeadership && <LeadershipLabel className="top-8" />}
      <div className="flex w-full items-end justify-between gap-4 p-8">
        <div className="flex flex-col gap-2">
          <NewsMetaData
            date={date}
            brand={brand}
            categories={categories}
            className="*:text-white dark:*:text-white"
          />
          <Typography
            size="xl"
            className="leading-[120%] font-semibold text-white lg:text-3xl"
          >
            <Link to={slug} state={linkState}>
              {/* Make sure the whole card is clickable */}
              <span className="absolute inset-0"></span>
              {title}
            </Link>
          </Typography>
        </div>
        <HoverArrow />
      </div>
    </div>
  );
};
